import Header from "@/components/Header";
import SiteFooter from "@/components/SiteFooter";
import PageHero from "@/components/PageHero";
import BookCTA from "@/components/BookCTA";
import BeforeAfterJob from "@/components/BeforeAfterJob";
import { GALLERY_JOBS } from "@/lib/galleryJobs";
import { usePageMeta } from "@/lib/seo";

export default function Gallery() {
  usePageMeta(
    "Before & After Gallery | House Clearance Peterborough",
    "See before and after photos of real house clearances in and around Peterborough by Waites Clearances, the family run clearance team based in Peterborough."
  );
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="page-gallery">
      <Header />

      <PageHero
        eyebrow="Gallery"
        title="Before and after — real Peterborough jobs, real homes."
        description="Here's a few of our recent clearances in and around Peterborough. Tap the Before / After toggle on each job to see the difference one visit from our team makes."
      />

      <section className="py-16 sm:py-20" data-testid="gallery-jobs">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 space-y-8 sm:space-y-10">
          {GALLERY_JOBS.map((job, i) => (
            <BeforeAfterJob
              key={job.slug}
              job={job}
              testid={`gallery-job-${i + 1}`}
            />
          ))}
        </div>
      </section>

      <BookCTA
        title="Want yours in the next after photo?"
        body="Get a free quote with a couple of photos and we'll come and clear it out anywhere in Peterborough — one visit, no fuss."
      />

      <SiteFooter />
    </div>
  );
}
